import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { MetaWhatsAppNumberPolicyPhone, WhatsAppPhoneStateColorMap } from '@/types';
import { phoneState } from '@/utils/whatsappMeta';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumberEligibilityState',
  props: {
    phone: { type: [Object, null], required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const { t } = useI18n();

const state = computed(() => phoneState(props.phone));

const badge = computed(() => WhatsAppPhoneStateColorMap[state.value]);

const __returned__ = { props, t, state, badge }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})